<template>
  <div>
    <div class="wrapper">
      <input type="radio" name="permanencia" id="permanencia-1" @click="selectedPerm('1 AÑO O MENOS')"/>
      <input type="radio" name="permanencia" id="permanencia-2" @click="selectedPerm('ENTRE 1 Y 2 AÑOS')"/>
      <input type="radio" name="permanencia" id="permanencia-3" @click="selectedPerm('ENTRE 2 Y 3 AÑOS')"/>
      <input type="radio" name="permanencia" id="permanencia-4" @click="selectedPerm('ENTRE 3 Y 5 AÑOS')"/>
      <input type="radio" name="permanencia" id="permanencia-5" @click="selectedPerm('MÁS DE 5 AÑOS')"/>
      <input type="radio" name="permanencia" id="permanencia-6" @click="selectedPerm('1 AÑO O MENOS,ENTRE 1 Y 2 AÑOS,ENTRE 2 Y 3 AÑOS, ENTRE 3 Y 5 AÑOS, MÁS DE 5 AÑOS')"/>

      <label for="permanencia-1" class="permanencia permanencia-1">
        <div class="dot"></div>
        <span>1 año o menos</span>
      </label>
      <label for="permanencia-2" class="permanencia permanencia-2">
        <div class="dot"></div>
        <span>Entre 1 y 2 años</span>
      </label>
      <label for="permanencia-3" class="permanencia permanencia-3">
        <div class="dot"></div>
        <span>Entre 2 y 3 años</span>
      </label>
      <label for="permanencia-4" class="permanencia permanencia-4">
        <div class="dot"></div>
        <span>Entre 3 y 5 años</span>
      </label>
      <label for="permanencia-5" class="permanencia permanencia-5">
        <div class="dot"></div>
        <span>más de 5 años</span>
      </label>
      <label for="permanencia-6" class="permanencia permanencia-6">
        <div class="dot"></div>
        <span>Todos</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    selectedPerm: function(selected) {
      this.$store.commit("setRHPerm", selected)
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Fira Sans", sans-serif;
}
html,
body {
  display: grid;
  height: 100%;
  place-items: center;
  background: #0069d9;
  font-family: "Fira Sans", sans-serif;
}
.wrapper {
  background: #fff;
  height: 100px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
}
.wrapper .permanencia {
  background: #e0e0e0;
  height: 50px;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  margin-right: 15px;
}

.wrapper .permanencia .dot::before {
  position: absolute;
  content: "";
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 0;
  transform: scale(1.5);
  transition: all 0.3s ease;
}
input[type="radio"] {
  display: none;
}
#permanencia-1:checked:checked ~ .permanencia-1,
#permanencia-2:checked:checked ~ .permanencia-2,
#permanencia-3:checked:checked ~ .permanencia-3,
#permanencia-4:checked:checked ~ .permanencia-4,
#permanencia-5:checked:checked ~ .permanencia-5,
#permanencia-6:checked:checked ~ .permanencia-6 {
  border-color: #24c6ab;
  background: #24c6ab;
}
#permanencia-1:checked:checked ~ .permanencia-1 .dot,
#permanencia-2:checked:checked ~ .permanencia-2 .dot,
#permanencia-3:checked:checked ~ .permanencia-3 .dot,
#permanencia-4:checked:checked ~ .permanencia-4 .dot,
#permanencia-5:checked:checked ~ .permanencia-5 .dot,
#permanencia-6:checked:checked ~ .permanencia-6 .dot {
  background: #fff;
}
#permanencia-1:checked:checked ~ .permanencia-1 .dot::before,
#permanencia-2:checked:checked ~ .permanencia-2 .dot::before,
#permanencia-3:checked:checked ~ .permanencia-3 .dot::before,
#permanencia-4:checked:checked ~ .permanencia-4 .dot::before,
#permanencia-5:checked:checked ~ .permanencia-5 .dot::before,
#permanencia-6:checked:checked ~ .permanencia-6 .dot::before {
  opacity: 1;
  transform: scale(1);
}

#permanencia-1:checked:checked ~ .permanencia-1 span,
#permanencia-2:checked:checked ~ .permanencia-2 span,
#permanencia-3:checked:checked ~ .permanencia-3 span,
#permanencia-4:checked:checked ~ .permanencia-4 span,
#permanencia-5:checked:checked ~ .permanencia-5 span,
#permanencia-6:checked:checked ~ .permanencia-6 span {
  color: #fff;
}

@media screen and (max-width: 1520px) {
  .wrapper .permanencia {
    height: 40px;
    width: 120px;
    font-size: 14px;
  }
}

@media screen and (max-width: 1000px) {
    .wrapper .permanencia {
    height: 30px;
    width: 90px;
    font-size: 10px;
  }
}

@media screen and (max-width: 770px) {
  .wrapper .permanencia {
    height: 30px;
    width: 80px;
    font-size: 9px;
    margin-right: 10px;
  }
}
</style>